var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upLoadImg" },
    [
      _c(
        "el-upload",
        {
          staticClass: "avatar-uploader",
          attrs: {
            action: _vm.uploadFileUrl,
            "show-file-list": false,
            "on-success": _vm.handleAvatarSuccess,
            "before-upload": _vm.beforeAvatarUpload,
          },
        },
        [
          _vm.imageUrl
            ? _c("img", {
                staticClass: "avatar upImg",
                attrs: { src: _vm.imageUrl },
              })
            : _c("i", { staticClass: "el-icon-plus avatar-uploader-icon" }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }